module.exports = __webpack_public_path__ + "static/media/althar.611ee0d2.jpg";